import React, { ReactNode } from "react"
import { PageContext as PageContextType } from "../types"

const PageContext = React.createContext<PageContextType | undefined>(undefined)

const usePageContext = () => {
    const context = React.useContext(PageContext)
    if (context === undefined) {
        throw new Error("usePageContext must be used within a PageProvider")
    }
    return context
}

interface PageProviderProps {
    children: ReactNode
    value: PageContextType
}

const PageProvider = ({ children, value }: PageProviderProps) => {
    return <PageContext.Provider value={value}>{children}</PageContext.Provider>
}

export { PageProvider, usePageContext }
